import { DateTime } from 'luxon'

import type { ActivationGroup } from '@/features/activationGroup/types'
import type { BidType } from '@/features/bidding/constants'
import { Status } from '@/features/bidding/constants'
import type { BidMetaData } from '@/features/bidding/types/bid'
import type { MarketDate } from '@/features/bidding/utils/date/marketDate'

const getBidMetaData = (deliveryDay: MarketDate, bidType: BidType, activationGroup: ActivationGroup): BidMetaData => ({
  status: Status.DRAFT,
  createdAt: DateTime.now(),
  deliveryDay: deliveryDay,
  portfolio: activationGroup.portfolio,
  marketProgram: activationGroup.marketProgram,
  activationGroupUuid: activationGroup.uuid,
  activationGroupName: activationGroup.code,
  bidType: bidType,
})

export default getBidMetaData
